import { useSelector } from "react-redux";
import { RootState } from "../../../app/store";
import { useEffect, useState } from "react";
import configUrls from "../../../config/configUrls";
import IconButton from '@mui/material/IconButton';
import ThumbUpOffAltOutlinedIcon from '@mui/icons-material/ThumbUpOffAltOutlined';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import { useNavigate } from 'react-router-dom'; // Importação para navegação
import { useSnackbar } from "notistack";
import errorFormat from "../../../utils/errorFormat";
import ThumbUp from "@mui/icons-material/ThumbUp";
import { useDarCienciaDocumentoMutation, useGetDocumentoCienciaDadaQuery } from "./DocumentoDarCienciaApiSlice";
import { Documento } from "../../../types/processo/Documento";



type Props = {
  documentoId: string;
};


export const ButtonPressDarCienciaDocumento = ({ documentoId }: Props) => {

  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate(); // Hook para navegação

  const [createDocumento, status] = useDarCienciaDocumentoMutation();

  // Hook para seleção do documento
  const { processoSelecionado } = useSelector((state: RootState) => state.processoSelecionado);
  const [cienciaDada, setCienciaDada] = useState(false);
  const { data, isFetching, error } = useGetDocumentoCienciaDadaQuery(documentoId);
  useEffect(() => {
    if (data) {     
      setCienciaDada(data);
    } else {
      
      setCienciaDada(false);
    }
  }, [data, error]);



  // Função para tratar o clique no botão
  const handleButtonPress = async () => {
    if (processoSelecionado) {
      try {
        // Dispara a mutação para "dar ciência" ao documento selecionado
        await createDocumento({ id: documentoId });
        //
      } catch (e) {
        console.error("Erro ao dar ciência ao documento:", e);
        enqueueSnackbar("Ocorreu um erro ao dar ciência ao documento!", { variant: "error" });
      }
    } else {
      enqueueSnackbar("Nenhum documento foi previamente selecionado", { variant: "error" });
    }
  };

  useEffect(() => {
    if (status.isError) {
      const erroReturn: string = errorFormat(status);
      enqueueSnackbar(erroReturn, { variant: "error" })
    }

    if (status.isSuccess) {
      setCienciaDada(true);
      enqueueSnackbar("Ciência dada ao documento com sucesso!", { variant: "success" });
      navigate(`${configUrls.DOCUMENTO_CIENCIA_LIST_LINK}${documentoId}`);
    }
  }, [status]);

  return (
    <IconButton
      color="secondary"
      size="large"
      onClick={handleButtonPress}
      disabled={status.isLoading}
    >
      {cienciaDada === true ? <ThumbUpIcon /> : <ThumbUpOffAltOutlinedIcon />}

    </IconButton>
  );
};


//{cienciaDada === true ? <ThumbUpIcon /> : <ThumbUpOffAltOutlinedIcon />}